import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { connect } from "react-redux";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import DatePicker from "../Common/DatePicker";
import CustomButton from "../Common/CustomButton";
import NotFound from "../NotFound";

import { setBreadcrumb } from "../../actions/common";
import { fetchPost } from "../../api/fetch";

import colors from "../../assets/style/colors";
import { TableBody, TableCell, Table, TableRow } from "@material-ui/core";
import { nowWithOutSeconds } from "../../utils/date";

const Stats = (props) => {
  const { dispatch, powerUserModeEnabled } = props;
  const [stats, setStats] = React.useState({});
  const [formValues, setFormValues] = React.useState({
    startDate: nowWithOutSeconds() - 86400000,
    endDate: nowWithOutSeconds(),
  });

  React.useEffect(() => {
    dispatch(setBreadcrumb([{ name: I18n.get("topbar_stats") }]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field, value) => {
    setFormValues(
      update(formValues, {
        [field]: { $set: new Date(value).getTime() },
      })
    );
  };

  const handleSearch = async () => {
    try {
      let dac = await fetchPost("system/statistics/dac", {
        start: formValues.startDate,
        end: formValues.endDate,
      });
      let lpr = await fetchPost("system/statistics/lpr", {
        start: formValues.startDate,
        end: formValues.endDate,
      });
      let ocr = await fetchPost("system/statistics/ocr", {
        start: formValues.startDate,
        end: formValues.endDate,
      });
      let fr = await fetchPost("system/statistics/fr", {
        start: formValues.startDate,
        end: formValues.endDate,
      });
      console.log(fr);
      let profiles = await fetchPost("system/statistics/profiles", {
        start: formValues.startDate,
        end: formValues.endDate,
      });
      setStats({ dac, lpr, ocr, fr, profiles });
    } catch (e) {
      console.log(e);
    }
  };

  const renderStatSection = (section) => {
    //if (stats[section])
    return (
      <>
        <Box
          className="bold-500"
          style={{
            margin: "20px 0px",
            padding: "10px",
            borderBottom: "1px solid " + colors.veryLighPink,
          }}
        >
          {I18n.get(`stats_${section}Title`)}
        </Box>
        <Table style={{ maxWidth: "600px" }}>
          <TableBody>
            {Object.keys(stats[section]).map(
              (k) =>
                typeof stats[section][k] !== "object" && (
                  <TableRow key={k}>
                    <TableCell>{k}</TableCell>
                    <TableCell>{stats[section][k]}</TableCell>
                  </TableRow>
                )
            )}
          </TableBody>
        </Table>
      </>
    );
  };

  if (!powerUserModeEnabled) {
    return <NotFound />;
  }

  return (
    <Box className="mainContainer">
      <Grid
        container
        direction="column"
        className="mainContent"
        style={{ padding: "12px", maxWidth: "1920px" }}
      >
        <Grid item style={{ marginTop: "20px" }}>
          <Grid container justify="center">
            <Grid item style={{ maxWidth: "300px", marginRight: "24px" }}>
              <DatePicker
                label={I18n.get("site_startDate")}
                name="startDate"
                value={formValues.startDate}
                onChange={handleChange}
              />
            </Grid>
            <Grid item style={{ maxWidth: "300px" }}>
              <DatePicker
                label={I18n.get("site_endDate")}
                name="endDate"
                value={formValues.endDate}
                onChange={handleChange}
              />
            </Grid>
            <Grid
              item
              style={{
                marginLeft: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CustomButton
                variant="contained"
                color="primary"
                style={{ margin: 0 }}
                onClick={handleSearch}
              >
                {I18n.get("site_search")}
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
        {stats &&
          Object.keys(stats).length > 0 &&
          ["dac", "lpr", "ocr", "fr", "profiles"].map((section) => (
            <Grid item key={section}>
              {renderStatSection(section)}
            </Grid>
          ))}
      </Grid>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    powerUserModeEnabled: state.common.powerUserModeEnabled,
  };
};

export default connect(mapStateToProps)(Stats);
